import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent implements OnInit {
  default: boolean = true;
  confirm: boolean = false;
  error: boolean = false;
  success: boolean = false;
  alert: boolean = false;
  confirmDelete: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalConfirmComponent>,
  ) { }

  ngOnInit(): void {
    this.default = false;
    this.confirm = false;
    this.error = false;
    this.success = false;
    this.alert = false;
    this.confirmDelete = false;

    const type = this.data?.type;

    switch (type) {
      case 'warning':
        this.default = true;
        break;
      case 'confirm':
        this.confirm = true;
        break;
      case 'success':
        this.success = true;
        break;
      case 'error':
        this.error = true;
        break;
      case 'alert':
        this.alert = true;
        break;
      case 'confirmDelete':
      case 'delete':
        this.confirmDelete = true;
        break;
      default:
        if (this.data?.error) this.error = true;
        else if (this.data?.confirm) this.confirm = true;
        else if (this.data?.success) this.success = true;
        else if (this.data?.alert) this.alert = true;
        else if (this.data?.confirmDelete) this.confirmDelete = true;
        else this.default = true;
    }
  }

  submit() {
    this.dialogRef.close({ confirm: true });
  }

  closeModal() {
    this.dialogRef.close({ confirm: false });
  }

}
